// Importaciones de todos los componentes de pasos
import PasswordChangeStep from './steps/PasswordChangeStep'
import CompanyDataStep from './steps/CompanyDataStep'
import PersonalDataStep from './steps/PersonalDataStep'
import CompanyBureauStep from './steps/CompanyBureauStep'
import BureauCheckStep from './steps/BureauCheckStep'
import ShareholderDataStep from './steps/ShareholderDataStep'
import ShareholderBureauStep from './steps/ShareholderBureauStep'
import CiecConsultationStep from './steps/CiecConsultationStep'
import LegalRepresentativeStep from './steps/LegalRepresentativeStep'
import DocumentUploadStep from './steps/DocumentUploadStep'
import ScheduleVisitStep from './steps/ScheduleVisitStep'
import QuoteReviewStep from './steps/QuoteReviewStep'
import PaymentMethodStep from './steps/PaymentMethodStep'
import ScheduleSigningStep from './steps/ScheduleSigningStep'

// Mapeo de step keys a componentes
export const STEP_COMPONENTS = {
  password_change: PasswordChangeStep,
  company_data: CompanyDataStep,
  personal_data: PersonalDataStep,
  company_bureau_check: CompanyBureauStep,
  bureau_check: BureauCheckStep,
  shareholder_data: ShareholderDataStep,
  shareholder_bureau_check: ShareholderBureauStep,
  ciec_consultation: CiecConsultationStep,
  legal_representative_data: LegalRepresentativeStep,
  document_upload: DocumentUploadStep,
  ocular_visit_scheduling: ScheduleVisitStep,
  quote_review_acceptance: QuoteReviewStep,
  payment_method_selection: PaymentMethodStep,
  contract_signing_scheduling: ScheduleSigningStep,
} as const

// Función para obtener el componente de un paso
export const getStepComponent = (stepKey: string) => {
  return STEP_COMPONENTS[stepKey as keyof typeof STEP_COMPONENTS]
}
